import { Alert as MUIAlert } from "@mui/material";

export const Alert = MUIAlert;
